import moment from "moment";
import {
  BASE_DATE_FORMAT,
  DATE_FORMAT_WITH_TIME,
  LONG_DATE_FORMAT
} from "@/constants/common.js";

export const baseDateFilter = date => {
  return moment(date).format(BASE_DATE_FORMAT);
};

export const longDatewithTimeFilter = date => {
  return date ? moment(date).format(DATE_FORMAT_WITH_TIME) : "";
};

export const longDateFilter = date => {
  return date ? moment(date).format(LONG_DATE_FORMAT) : "";
};
